import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=2b20ec2c&"
import script from "./breadcrumb.vue?vue&type=script&lang=js&"
export * from "./breadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b20ec2c')) {
      api.createRecord('2b20ec2c', component.options)
    } else {
      api.reload('2b20ec2c', component.options)
    }
    module.hot.accept("./breadcrumb.vue?vue&type=template&id=2b20ec2c&", function () {
      api.rerender('2b20ec2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/navbar/components/breadcrumb.vue"
export default component.exports